import React from 'react';
import { HiXMark } from 'react-icons/hi2';

const ModalActionHeader = ({ title, Icon, onClose }) => (
  <div className={`te-action-modal-head ${title ? '' : 'is-bare'}`}>
    {title && (
      <div className="te-action-modal-title">
        {Icon && (
          <span className="te-action-modal-icon">
            <Icon aria-hidden="true" />
          </span>
        )}
        <h2>{title}</h2>
      </div>
    )}
    {onClose && (
      <button type="button" className="te-action-modal-close" onClick={onClose} aria-label="Close" data-testid="action-modal-close">
        <HiXMark aria-hidden="true" />
      </button>
    )}
  </div>
);

export default ModalActionHeader;
